import { createContext } from "react";

export const DataContext = createContext({
  user: {} as any,
  changeUser: (user:any) => {},
  token: {},
  changeToken: (token:String) => {},
  loading: true,
  toggleReloadParent: () => {},
  reloadParent: false,
  showLoader: false,
  changeShowLoader: (loader:boolean) => {},
  organizationList: [],
  changeOrganizationList: (list:any) => {},
  currentOrganization: '',
  changeCurrentOrganization: (organization:string) => {},
  assessmentList: [],
  changeAssessmentList: (list:any) => {},
  currentAssessment: '',
  changeCurrentAssessment: (assessment:string) => {},
  currentControl: {} as any,
  changeCurrentControl: (control:string) => {},
  language: 'it',
  changeLanguage: (language:string) => {},
  maturities: [],
  coverages: [],
  darkMode: false,
  changeDarkMode: (dark:boolean) => {},
});